// import { useEffect, useState } from "react";

import { useEffect, useState } from "react";
import { Header } from "../../components/Header";
import WhatsappButton from "../../components/WhatsappButton";
import {
  MainContainer,
  Content,
  TitleContainer,
  InfoContainer,
  ButtonContainer,
  Button,
} from "./styled";
import api from "../../api/axios";
import { useNavigate, useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import { toast } from "react-toastify";
import FullScreenLoader from "../../components/FullScreenLoader";

const OportunidadeDetail = () => {
  const [oportunidade, setOportunidade] = useState(null);
  const [oportunidadeAtiva, setOportunidadeAtiva] = useState(true);

  const [isLoading, setIsLoading] = useState(true);

  const { oportunidadeId } = useParams();
  const navigate = useNavigate();

  const getOportunidade = async () => {
    try {
      setIsLoading(true);

      // await new Promise((resolve) => setTimeout(resolve, 1000));
      const hoje = new Date();

      const res = await api.get("/oportunity/search/" + oportunidadeId);

      if (
        res.data.fim_vigencia &&
        res.data.fim_vigencia < hoje + 1000 * 60 * 60 * 24
      )
        setOportunidadeAtiva(false);

      setOportunidade(res.data);
    } catch (err) {
      console.error("Ocorreu um erro:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const sanitizeHtml = (html) => {
    const safeHtml = DOMPurify.sanitize(html);

    return <div dangerouslySetInnerHTML={{ __html: safeHtml }} />;
  };

  const handleApplyClick = async () => {
    try {
      const res = await api.get("/user/me");
      if (res.data._id) {
        navigate("/candidatar/" + oportunidade._id);
      }
    } catch (err) {
      if (err.status === 401) {
        navigate("/cadastro-oportunidade/" + oportunidade._id);
        return;
      }

      if (err.response?.data?.message) {
        toast.error("Ocorreu um erro: " + err.response?.data?.message);
      } else {
        toast.error("Ocorreu um erro");
      }
    }
  };

  useEffect(() => {
    if (oportunidadeId) getOportunidade();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oportunidadeId]);

  return (
    <Content>
      <FullScreenLoader fadeOut={!isLoading} />
      <WhatsappButton />
      <Header />
      {oportunidadeAtiva ? (
        <MainContainer>
          <TitleContainer>
            <span>
              {isLoading
                ? "Carregando"
                : !oportunidadeId || !oportunidade
                  ? "Erro"
                  : oportunidade.cargo}
            </span>
          </TitleContainer>
          <InfoContainer>
            {isLoading ? (
              <></>
            ) : !oportunidadeId || !oportunidade ? (
              <div
                style={{
                  textAlign: "center",
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#edf1f6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#104467",
                  fontSize: "1.25rem",
                }}
              >
                <span>Essa oportunidade não existe</span>
              </div>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "60%",
                    minWidth: "300px",
                    padding: "20px",
                    alignSelf: "center",
                  }}
                >
                  <div>
                    <span style={{ fontWeight: "bold" }}>{`Cargo/função: ${
                      oportunidade.cargo || ""
                    }`}</span>
                  </div>
                  {oportunidade.local ? (
                    <div>
                      <span style={{ fontWeight: "bold" }}>{`Local: ${
                        oportunidade.local || ""
                      }`}</span>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div>
                    <span style={{ fontWeight: "bold" }}>{`Remuneração: ${
                      oportunidade.remuneracao > 0
                        ? oportunidade.remuneracao
                        : "A combinar"
                    }`}</span>
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>{`Empresa: ${
                      oportunidade.empresa || ""
                    }`}</span>
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>{`Tipo de vínculo: ${
                      oportunidade.vinculo || ""
                    }`}</span>
                  </div>
                  <div>
                    <span
                      style={{ fontWeight: "bold" }}
                    >{`Regime de trabalho: ${oportunidade.regime || ""}`}</span>
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <div style={{ marginBottom: "5px" }}>
                      <span>Tecnologias:</span>
                    </div>
                    <p>{oportunidade.skills.join(", ") || ""}</p>
                  </div>
                  <div
                    style={{
                      marginTop: "50px",
                      whiteSpace: "pre-wrap",
                      textAlign: "justify",
                    }}
                  >
                    {sanitizeHtml(oportunidade.descricao || "")}
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <ButtonContainer>
                    <Button
                      onClick={() =>
                        (window.location.href =
                          "https://ticoopbrasil.coop.br/oportunidades-ti/")
                      }
                    >
                      Voltar a página de oportunidades
                    </Button>
                    <Button onClick={handleApplyClick} bgColor={"#104467"}>
                      Candidatar a esta oportunidade
                    </Button>
                  </ButtonContainer>
                </div>
              </>
            )}
          </InfoContainer>
        </MainContainer>
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{ fontSize: "1.4rem", color: "#104467", fontWeight: 600 }}
          >
            Esta oportunidade está inativa
          </span>
        </div>
      )}
    </Content>
  );
};

export default OportunidadeDetail;
